import { createSlice } from "@reduxjs/toolkit";

export const customerSlice = createSlice({
    name: 'customers',
    initialState: {
        value: []
    },
    reducers: {
        addCustomer: (state, action) => {
            state.value.push( action.payload );
        },
        addMany: (state, action) => {
            state.value = [ ...state.value, ...action.payload ];
        },
        setCustomers: (state, action) => {
            state.value = action.payload;
        },
        updateCustomer: (state, action) => {
            const index = state.value.findIndex(a => a.id === action.payload.id);
            if (index !== -1) {
                state.value[index] = action.payload;
            }
        },
    }
});

export const { addCustomer, addMany, setCustomers, updateCustomer} = customerSlice.actions;

export default customerSlice.reducer;